import { Divider, Form, Input, message } from 'antd'
import { useState } from 'react'
import { CDNImage } from '~/components/business/CDNImage'
import { MyForm } from '~/components/ui/MyForm'
import { MyModal } from '~/components/ui/MyModal'
import { graphQLErrorMessage } from '~/utils'
import { SUBMIT_INTENTION } from '~/graphqls/gqls'
import { useMutation } from '@apollo/client'
import {
  submitIntention,
  submitIntentionVariables,
  CompanyIntentionType,
} from '~/graphqls/types'
import { LabeledValue } from 'antd/lib/select'
import styles from './ConsultModal.module.css'
import classNames from 'classnames'

const qrcodeList = [
  {
    key: '1',
    text: '个人商务咨询',
    url: '/images/mirror/personal-qrcode.jpg',
  },
  {
    key: '2',
    text: '企业商务咨询',
    url: '/images/mirror/business-qrcode.jpg',
  },
]

const serviceOptions = [
  { value: '1', label: '个人' },
  { value: '2', label: '企业' },
]

const ServiceSelect: React.FC<{
  value?: string
  onChange?: (val?: string) => void
  options: { value: string; label: string }[]
}> = ({ value, onChange, options }) => {
  return (
    <div className="flex">
      {options.map(it => (
        <div
          key={it.value}
          onClick={() => onChange?.(it.label)}
          className="w-full flex justify-center items-center border-2 border-neutral-600 rounded-[8px] py-2 cursor-pointer mr-6 last:mr-0"
        >
          <div
            className={classNames(
              'w-4 h-4 rounded-full border-2 border-neutral-600',
              { ['border-4 border-[#7851EC]']: it.label === value }
            )}
          ></div>
          <div className="text-sm text-neutral-200 font-semibold ml-2">
            {it.label || it.value}
          </div>
        </div>
      ))}
    </div>
  )
}

const ConsultModal: React.FC<{
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ visible = true, setVisible }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const onCancel = () => {
    setVisible(false)
    form.resetFields()
  }
  const [submitAction] = useMutation<submitIntention, submitIntentionVariables>(
    SUBMIT_INTENTION
  )
  const onSubmit = async () => {
    const values = await form.validateFields()
    try {
      if (!values || loading) return
      setLoading(true)
      const res = await submitAction({
        variables: {
          input: { ...values, type: CompanyIntentionType.MIRROR },
        },
      })
      if (res.data?.itemModule?.status) {
        message.destroy()
        message.success('提交成功')
        onCancel()
      }
    } catch (err) {
      message.destroy()
      message.error(graphQLErrorMessage(err) || '提交失败')
    } finally {
      setLoading(false)
    }
  }
  return (
    <MyModal
      title="合作咨询"
      width={576}
      open={visible}
      onCancel={onCancel}
      centered
      footer={null}
      zIndex={1002}
    >
      <div className="text-neutral-400 text-xs mb-8">
        你可以添加商务微信进行在线沟通，或者填下你的信息稍后商务主动联系您沟通合作具体事项
      </div>
      <div>
        <MyForm
          className="flex-1"
          name="submitForm"
          form={form}
          layout="vertical"
          initialValues={{ cooperationScene: '个人' }}
        >
          <MyForm.Item
            name="personalName"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名' }]}
          >
            <Input placeholder="请输入姓名" maxLength={20} />
          </MyForm.Item>
          <MyForm.Item
            name="mobile"
            label="手机号"
            rules={[
              { required: true, message: '请输入手机号' },
              { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
            ]}
          >
            <Input placeholder="请输入手机号" />
          </MyForm.Item>
          <MyForm.Item
            name="cooperationScene"
            label="期望合作场景"
            rules={[{ required: true, message: '请选择合作场景' }]}
            className={styles.noBorder}
          >
            <ServiceSelect options={serviceOptions} />
          </MyForm.Item>
        </MyForm>
        <div
          className="flex items-center justify-center h-10 rounded-full text-sm font-semibold text-neutral-900 cursor-pointer mt-8"
          onClick={onSubmit}
          style={{
            background:
              'linear-gradient(321deg, #6964DE -10.33%, #FCA6E9 100%)',
            boxShadow:
              '0px 20px 28px 0px rgba(139, 92, 246, 0.36), 0px 76px 52px 0px rgba(139, 92, 246, 0.20)',
          }}
        >
          确认提交
        </div>
        <Divider
          style={{ margin: '32px 0' }}
          className="!text-base !text-neutral-500 !border-t-neutral-500 opacity-50"
        >
          OR
        </Divider>
        <div className="flex justify-between items-center">
          <div className="text-neutral-400 text-sm font-semibold">
            扫描右侧二维码
            <br />
            咨询合作事宜
          </div>

          <div className="flex">
            {qrcodeList.map(it => (
              <div
                key={it.key}
                className="flex flex-col items-center justify-center mr-8 last:mr-0"
              >
                <div className="w-[90px] h-[90px] rounded-[5px] border border-solid border-neuteal-600">
                  <CDNImage className="w-full h-full" src={it.url} />
                </div>
                <div className="texs-xs text-neutral-400 font-semibold mt-2">
                  {it.text}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </MyModal>
  )
}

export default ConsultModal
